'use client';

import {TabKey} from 'common/types';
import {track} from 'iq-tracking';
import {useEffect, useRef} from 'react';
import {usePathname} from 'next/navigation';

interface Tab {
  key: TabKey;
  label: string;
}

interface TabBarProps {
  tabs: Tab[];
  activeTab: TabKey;
  onTabChange: (tab: TabKey) => void;
}

export default function TabBar({tabs, activeTab, onTabChange}: TabBarProps) {
  const pathname = usePathname();
  const initialMount = useRef(true);

  useEffect(() => {
    if (initialMount.current) {
      initialMount.current = false;
      return;
    }
    const slug = pathname.split('/').filter(Boolean).at(-1) ?? '';
    void track({
      event: 'guide_tab_viewed',
      action: 'view',
      component: 'page',
      content_type: 'guide',
      content_identifier: slug,
      extra: {extra_data: JSON.stringify({tab: activeTab})},
    });
  }, [activeTab, pathname]);

  return (
    <div className='bg-white border-b border-iq-grey-light sticky top-0 z-10 shadow-[0_4px_8px_0_rgba(255,255,255,0.9)] w-full'>
      <div className='flex gap-x-10 max-[570]:gap-x-2'>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`
              py-4 px-1 text-sm max-[450]:text-xs border-b-2 transition-colors
              ${
                activeTab === tab.key
                  ? 'border-iq-black text-iq-black font-semibold'
                  : 'border-transparent text-iq-grey-medium hover:text-iq-grey-dark'
              }
            `}>
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}
